import Navbar from "./components/Navbar";
import Hero from "./components/Hero";

export default function Home() {
  return (
    <main className="min-h-screen w-full bg-white font-sans overflow-x-hidden">
      <Navbar />
      <Hero />
    </main>
  );
}